import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(theme => ({
  videoSection: {
    padding: "60px 300px 45px 300px",
    [theme.breakpoints.down("md")]: {
      padding: "60px 100px"
    },
    [theme.breakpoints.down("xs")]: {
      padding: "32px 20px 32px 32px"
    }
  },
  videoSectionContainer: {
    marginBottom: "70px"
  },
  bannerTitle: {
    fontSize: "42px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.1",
    color: "#00338d",
    maxWidth: "405px",
    marginBlockStart: "0em",
    marginBlockEnd: "0em",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      fontSize: "36px",
      maxWidth: "250px"
    }
  },
  bannerRectangle: {
    width: "10px",
    height: "45px",
    background: "#0073cf",
    display: "inline-block",
    marginRight: "23px",
    [theme.breakpoints.down("xs")]: {
      top: "0px",
      left: "-20px",
      width: "8px",
      height: "40px",
      position: "absolute"
    }
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.secondary,
    minHeight: "180px",
    background: "#fafafa",
    cursor: "pointer",
    position: "relative",

    "&:hover": {
      boxShadow:
        "0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)"
    }
  },
  root: {
    flexGrow: 1,
    padding: "40px 300px 40px 300px",
    background:
      "linear-gradient(to right, rgba(0,152,219,0.3) 0%,rgba(0,152,219,0.31) 1%,rgba(255,255,255,0.65) 50%,rgba(255,255,255,1) 100%)",
    [theme.breakpoints.down("md")]: {
      padding: "60px 100px"
    },
    [theme.breakpoints.down("sm")]: {
      padding: "60px 40px"
    },
    [theme.breakpoints.down("xs")]: {
      padding: "32px 20px 32px 32px"
    }
  },
  relativeMobile: {
    [theme.breakpoints.down("xs")]: {
      position: "relative"
    }
  },
  cardTtitle: {
    fontSize: 20,
    fontWeight: 500,
    fontStyle: "normal",
    lineHeight: "1.17",
    color: "rgba(0, 0, 0, 0.87)",
    marginTop: "0px"
  },
  cardDescription: {
    fontSize: 13,
    fontWeight: "normal",
    fontStyle: "normal",
    lineHeight: "1.25",
    color: "#727272"
  },
  playIndicator: {
    textAlign: "right",
    display: "flex",
    justifyContent: "flex-end",
    cursor: "pointer",
    alignItems: "center",
    position: "absolute",
    right: "10px",
    bottom: "10px"
  },
  marginRight1: {
    marginRight: 5
  }
}));

export default styles;
